'use client';

import React from 'react';

import type { TDynamicData } from '@eliadmin/core/src/types/dynamic-data';

import { fetchDynamicSections } from '@eliadmin/core/src/api/dynamics/dynamics-api';
import { Button } from '@eliadmin/core/src/components/ui/button';

import { useVariantsStore } from '@eliadmin/core/src/stores/variant-store';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { useQuery } from '@tanstack/react-query';
import {
  ResponsiveDialog,
  ResponsiveDialogTrigger,
  ResponsiveDialogContent,
} from '@eliadmin/core/src/components/ui/responsive-dialog';
import { HtmlRenderer } from '@eliadmin/core/src/components/ui/html-renderer';

export function ProductActions() {
  //const settings = useGlobalStore(state => state.templateSettings);
  const product = useVariantsStore(s => s.product);
  //const open = useResponsiveDialogStore(state => state.open);

  const { data: content } = useQuery({
    queryKey: [],
    queryFn: () =>
      fetchDynamicSections<TDynamicData>({
        locale: 'sk',
        sectionIds: [8],
        query: {
          valueFilters: [{ fieldId: 18, values: product.name }],
        },
      }),
  });

  content?.map(data => {
    console.log(data);
  });

  if (!content?.length) {
    return null;
  }

  return (
    <div className="flex w-fit flex-col gap-1">
      {content.map(data2 => (
        <ResponsiveDialog key={data2.id}>
          <ResponsiveDialogTrigger asChild>
            <Button variant={'outline'} className="w-full">
              {data2.fields[0]?.value}
            </Button>
          </ResponsiveDialogTrigger>
          <ResponsiveDialogContent
            dialogProps={{
              className:
                'max-w-screen px-0 pt-10 max-h-[94vh] w-[680px] overflow-y-auto sm:max-w-[600px] md:max-w-[680px] lg:max-w-[800px] ea-jobportal-add-skill-dialog__content ea-jobportal-dialog__content',
            }}
            drawerProps={{
              className:
                'pb-6 max-h-screen ea-jobportal-add-skill-dialog__content ea-jobportal-dialog__content',
            }}
          >
            <div className="flex flex-col">
              <HtmlRenderer
                html={data2.fields[1]?.value ?? 'Prázdny popis'}
                className={cn(
                  'custom-scrollbar max-h-[100vh] w-full !overflow-y-auto md:max-h-[70vh]',
                  'ea-product-actions__content',
                )}
              />
            </div>
          </ResponsiveDialogContent>
        </ResponsiveDialog>
      ))}
    </div>
  );
}
